import axios from "axios";
import {AUTH_TOKEN} from "../SharingConstants";

const baseURL = `${window.location.origin}`;

const RestService = {
    reGenerateLink: async (data, token) => {

        try {
            const response = await axios.post(`${baseURL}/dashboard/sharing_module/update_uploaded_file`, data, {
                headers: {
                    "X-CSRF-Token": token,
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem(AUTH_TOKEN)
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
}

export default RestService;